import { render } from "./TourChurchPin.vue?vue&type=template&id=6ff7e72c"
import script from "./TourChurchPin.vue?vue&type=script&lang=js"
export * from "./TourChurchPin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__